import { IMessage } from "../interfaces";
import { MESSAGE_COMPONENT_TYPE } from "../enums";
import { getUniqId, urlify } from ".";

export const validateAndModify = function (value: IMessage) {
  try {			
    (value.contents?.structures ?? []).forEach(structure => {
        // SD-8114: Assign a stable UUID for Vue list rendering only.
        structure.__key = getUniqId();

        (structure.components ?? []).forEach(component => {
            if (component.type === MESSAGE_COMPONENT_TYPE.Text) {
                component.content = urlify(component.content);
            }
            if (component.style == null) {
                component.style = {};
            }
        });
    });
    return value;
	} catch (ex) {
		//console.error("[validate_and_modify.ts] Error in validateAndModify:", ex);
		return value;
	}
}
